import { kROUser } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const GroupExists = (groupList, groupID) => {
  var theSecurityObjects = JSON.parse(JSON.stringify(groupList));
  return groupID in theSecurityObjects;
};

export const SetAccessGroupsToJSON = function (accountConfig, updatedGroup, existingGroupID) {
  let groupList = accountConfig?.security?.groups;
  if (!groupList) return;
  let groupObj = {};
  let newGroup = !GroupExists(groupList, existingGroupID);
  if (!newGroup) groupObj = groupList[existingGroupID];

  groupObj["name"] = updatedGroup["name"].trim();
  groupObj["canExportExcel"] = updatedGroup["canExportExcel"];
  groupObj["canEditTemplates"] = updatedGroup["canEditTemplates"];
  groupObj["rowLevelSecurity"] = updatedGroup["rowLevelSecurity"];
  groupObj["limitToSelf"] = updatedGroup["limitToSelf"];
  groupObj["chartAccess"] = updatedGroup["chartAccess"];
  groupObj["views"] = updatedGroup["views"];
  groupObj["folders"] = updatedGroup["folders"];
  groupObj["pointintime"] = updatedGroup["pointintime"];
  groupObj["allowedFilters"] = updatedGroup["allowedFilters"];
  groupObj["allowedHighlights"] = updatedGroup["allowedHighlights"];
  groupObj["interactiveFiltering"] = updatedGroup["interactiveFiltering"];
  groupObj["reporting"] = updatedGroup["reporting"];

  if (!updatedGroup["rowsecprofile"]) delete groupObj["rowsecprofile"];
  else groupObj["rowsecprofile"] = updatedGroup["rowsecprofile"];

  if (!updatedGroup["branchLevelSecurity"]) delete groupObj["branchLevelSecurity"];
  else groupObj["branchLevelSecurity"] = updatedGroup["branchLevelSecurity"];

  if (!updatedGroup["roleassignment"]) delete groupObj["roleassignment"];
  else groupObj["roleassignment"] = updatedGroup["roleassignment"];

  if (!updatedGroup["uiprofile"]) delete groupObj["uiprofile"];
  else groupObj["uiprofile"] = updatedGroup["uiprofile"];

  if (!updatedGroup["roleassignment"] || updatedGroup["roleassignment"] == kROUser)
    delete groupObj["privatefolderaccess"];
  else groupObj["privatefolderaccess"] = updatedGroup["privatefolderaccess"];

  if (newGroup) groupList[existingGroupID] = groupObj;

  return groupList;
};

const ValidateGroupName = (accountConfig, theGroup) => {
  var o = theGroup["name"];
  o = o.trim();
  var msg = "";

  if (o.length === 0) msg = appstr("agroupnamemin");
  else {
    msg = !CheckGroupNameInUse(accountConfig, o, theGroup["name"]);
    if (!msg) msg = appstr("agroupnameused");
  }

  return msg;
};

const CheckGroupNameInUse = (accountConfig, newGroupName, curGroupName) => {
  newGroupName = newGroupName.toLowerCase();
  let groupList = accountConfig?.security?.groups;
  if (curGroupName) curGroupName = curGroupName.toLowerCase();

  var fullAccess = appstr("fullaccess").toLowerCase();
  var nameInUse = false;

  if (newGroupName == fullAccess) nameInUse = true;

  if (!nameInUse) {
    for (var aGroup in groupList) {
      var g = groupList[aGroup]["name"].toLowerCase();

      if (g !== curGroupName && g === newGroupName) {
        nameInUse = true;
        break;
      }
    }
  }

  return nameInUse;
};

export const CheckValidGroupConfig = function (accountConfig, editGroup) {
  let msg = "";
  let errorKeys = [];
  if (editGroup["roleassignment"] === true) {
    msg = appstr("You must select a role");
    errorKeys.push("roleassignment");
  }
  if (editGroup["uiprofile"] === true) {
    msg = appstr("You must select a UI profile");
    errorKeys.push("uiprofile");
  }
  if (msg.length === 0) {
    let validName = ValidateGroupName(accountConfig, editGroup);
    if (validName === true) msg = "";
    else {
      msg = validName;
      errorKeys.push("name");
    }
  }
  let groupValid = msg.length === 0;
  return { groupValid, msg, errorKeys };
};
